import { useState } from 'react';
import {
    IonButtons,
    IonButton,
    IonHeader,
    IonContent,
    IonToolbar,
    IonPage,
    IonItem,
    IonLabel,
    IonInput,
    IonSelect,
    IonSelectOption,
    IonTextarea,
    IonCol,
    IonFooter,
    IonGrid,
    IonRow,
    IonIcon
} from '@ionic/react';

import { chevronBack } from 'ionicons/icons';
import { duplicateEvent } from '../firebase/events';


const EventDuplicateDialog = ({
    onDismiss, event
}: {
    onDismiss: (data: any, role: string) => void;
    event: any
}) => {


    const [period, setPeriod] = useState<any>(0);
    const [occurrences, setOccurrences] = useState<any>(1);

    function hide() {
        onDismiss(null, 'cancel')
    }

    function save() {
        duplicateEvent({event:event, period: period,  occurrences: occurrences});
        onDismiss(null, 'save')
    }


    let periods = [];
    periods.push({id:0, name: "co tydzień"});
    periods.push({id:1, name: "co 2 tygodnie"});
    periods.push({id:2, name: "co 3 tygodnie"});
    periods.push({id:3, name: "co 4 tygodnie"});
    periods.push({id:4, name: "dni pon-pt"});
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="medium" onClick={() => hide()}>
                            <IonIcon icon={chevronBack}/>
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <IonItem>
                    <IonLabel>Cykliczność</IonLabel>
                    <IonSelect style={{maxWidth:"100%"}} interface="popover" value={period} onIonChange={(e) => { setPeriod(e.detail.value) }} placeholder="Wybierz szablon">
                        {periods.map(t => {
                            return <IonSelectOption key={t.id} value={t.id}>{t.name}</IonSelectOption>
                        })}
                    </IonSelect>
                </IonItem>
                <IonItem>
                    <IonLabel>Ilość powtórzeń</IonLabel>
                    <IonInput style={{ textAlign: "right" }} slot="end" placeholder="Cena" type="number" value={occurrences} onIonChange={(e) => setOccurrences(e.detail.value)}></IonInput>
                </IonItem>
            </IonContent>

            <IonFooter>
                <IonGrid>
                    <IonRow style={{ textAlign: "center" }}>
                        <IonCol>
                            <IonButton color="primary" onClick={() => {  save()}}>ustaw</IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>
        </IonPage>
    );
};

export default EventDuplicateDialog;

